import {
  getPaginated,
  PaginatedRequest,
  PaginatedResponse,
} from "@/application/api/getPaginated";
import { AxiosResponse } from "axios";
import mapIndexResponseErrors from "@/application/util/mapIndexResponseErrors";

export interface ProductIndexItem {
  id: number;
  articleNumber?: string;
  name?: string;
  salesCode: string;
  minimumStock: number;
  physicalStock: number;
  stock: number;
  announcedStock: number;
  warehouseStatus: number;
}

export const clientProductIndex = async (
  data: PaginatedRequest,
  clientId: number
): Promise<AxiosResponse<PaginatedResponse<ProductIndexItem[]>>> => {
  const response = await getPaginated(`client/${clientId}/product`, data);
  response.data.data = mapIndexResponseErrors(response.data.data);

  return response;
};
